/**
 * Mapping pur des codes d'erreur MFA U2106 (BL-0413).
 * Préfère la description API quand elle est présente.
 */

export const U2106_MFA_ERROR_CODES = {
  INVALID_CODE: 'BU210607',
  ENROLLMENT_NOT_STARTED: 'BU210608',
  ALREADY_ENABLED: 'BU210609',
  NOT_ENABLED: 'BU210610',
  PROOF_INVALID: 'BU210611',
  SSO_PATH_DISABLED: 'BU210612',
} as const;

export type U2106MfaErrorCode = (typeof U2106_MFA_ERROR_CODES)[keyof typeof U2106_MFA_ERROR_CODES];

const ERROR_I18N_KEYS: Record<U2106MfaErrorCode, string> = {
  BU210607: 'myAccount.mfa.errors.invalidCode',
  BU210608: 'myAccount.mfa.errors.enrollmentNotStarted',
  BU210609: 'myAccount.mfa.errors.alreadyEnabled',
  BU210610: 'myAccount.mfa.errors.notEnabled',
  BU210611: 'myAccount.mfa.errors.proofInvalid',
  BU210612: 'myAccount.mfa.errors.ssoPathDisabled',
};

export type U2106MfaApiErrorFragment = {
  errorCode?: string;
  description?: string;
};

type TranslateFn = (key: string, options?: Record<string, unknown>) => string;

/** Résout le message MFA : description API en priorité, sinon clé i18n. */
export function u2106ResolveMfaErrorMessage(
  err: U2106MfaApiErrorFragment,
  t: TranslateFn,
  nameSpace: string,
): string {
  const description = err.description?.trim();
  if (description) {
    return description;
  }

  const code = err.errorCode as U2106MfaErrorCode | undefined;
  if (code && code in ERROR_I18N_KEYS) {
    return t(ERROR_I18N_KEYS[code], { ns: nameSpace });
  }

  return t('myAccount.mfa.errors.generic', { ns: nameSpace, errorCode: err.errorCode ?? '' });
}

/** True si le code est un code métier MFA U2106 connu. */
export function u2106IsMfaErrorCode(code: string | undefined): code is U2106MfaErrorCode {
  return !!code && code in ERROR_I18N_KEYS;
}
